import { z } from 'zod';
import { ResponseParseJsonError } from 'libs/end-to-end/src/types/errors/response-parse-json-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { ZodParseError } from 'libs/end-to-end/src/types/errors/zod-parse-error';
import { JsonParseError } from 'libs/end-to-end/src/types/errors/json-parse-error';

export const ResponseToJsonError = z.union([
  ZodParseError,
  ResponseParseJsonError,
  JsonParseError,
  UnknownError,
]);

export type ResponseToJsonError = z.infer<typeof ResponseToJsonError>;
